import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const PortalLogin = lazy(() => import('../pages/portal/login/page'));
const PortalRegister = lazy(() => import('../pages/portal/register/page'));
const PortalDashboard = lazy(() => import('../pages/portal/dashboard/page'));
const PortalResetPassword = lazy(() => import('../pages/portal/reset-password/page'));
const AdminLogin = lazy(() => import('../pages/admin/login/page'));
const AdminDashboard = lazy(() => import('../pages/admin/dashboard/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/portal/login',
    element: <PortalLogin />,
  },
  {
    path: '/portal/register',
    element: <PortalRegister />,
  },
  {
    path: '/portal/dashboard',
    element: <PortalDashboard />,
  },
  {
    path: '/portal/reset-password',
    element: <PortalResetPassword />,
  },
  {
    path: '/admin/login',
    element: <AdminLogin />,
  },
  {
    path: '/admin/dashboard',
    element: <AdminDashboard />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
